import * as React from "react"
import {Box} from "@mui/material";

import {isGroupedByCountry, isGroupedByRetailer} from "@signals";
import {usePriceDiscountCountryWiseText} from "./@hooks";


const LegendBlock = ({ label, value }) => <Box>
	<Box component="strong" sx={{ pr: .5 }}>
		{label}
	</Box>
	{value}
</Box>

export default function CountryWiseTooltip() {
	const { averageLabel, skuLabel } = usePriceDiscountCountryWiseText()

	const labelName = isGroupedByCountry.value ? "country" : "label"
	const needFlag = isGroupedByCountry.value || isGroupedByRetailer.value

	return <Box sx={{ p: 1 }}>
		<Box sx={{ fontSize: 18, fontWeight: 'bold' }}>
			<Box component="span" sx={{ pl: needFlag ? 1 :  0 }}>
				{`{${labelName}}`}
			</Box>
		</Box>
		<LegendBlock label={`${averageLabel}:`} value={'{valueX.formatNumber("#.##\'%\'")}'} />
		<LegendBlock label={`${skuLabel}:`} value='{valueY.formatNumber("#,###")}' />
		<LegendBlock label="Total SKU's:" value='{value.formatNumber("#,###")}' />
	</Box>
}